
<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
    <HelloWorld msg="绸缪行止"/>
    <label>
      “绸缪行止”这个表达非常富有诗意和深意。在这里，“绸缪”一词源自《诗经》中的“绸缪牖户”，原意是紧密缠缚，用以加固门窗，后引申为事先做好准备，防患于未然。而“行止”则指的是行动和举止，包括了个人的日常活动、行程安排以及行为方式等。

      将“绸缪”与“行止”相结合，形成“绸缪行止”这一表达，意味着在行动之前深思熟虑，周密计划，以确保每一步都稳妥可靠，不出现差错。这种态度体现了对生活的认真和负责，也展现了一种高瞻远瞩、未雨绸缪的智慧。

      在日常生活中，我们可以将“绸缪行止”作为自己的座右铭，时刻提醒自己做事要有计划性，不能盲目行动。无论是工作、学习还是生活琐事，都应该提前做好准备，考虑到各种可能性和风险，并制定相应的应对措施。这样，我们才能在面对困难和挑战时从容不迫，稳操胜券。

      同时，“绸缪行止”也提醒我们要有远见卓识，不能只顾眼前利益而忽视长远规划。只有站在更高的角度审视问题，才能做出更加明智的决策，为自己的未来奠定坚实的基础。
    </label>
    <p>Plan meticulously for every step</p>
    <el-link type="primary" href="/login">Login</el-link>
    <!--  <el-footer>-->
    <!--  </el-footer>-->
    <Footer />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import Footer from './Footer.vue'
export default {
  name: 'HomeView',
  components: {
    // HelloWorld
    Footer
  }
}
</script>
